import { defaultTo } from "lodash";
import { IModel, Model } from "./Model";

export interface ITraitModel extends IModel {
    traitId: number;
    name: string;
    isForSalesCategories: boolean;
    isForSalesSubCategories: boolean;
    isForSalesItems: boolean;
    isForVisitSalesItems: boolean;
    isForVeterinarians: boolean;
    isForUsers: boolean;
    isForStates: boolean;
    isForStores: boolean;
    isForHospitals: boolean;
}

export class TraitModel extends Model implements ITraitModel {
    traitId: number;
    name: string;
    isForSalesCategories: boolean;
    isForSalesSubCategories: boolean;
    isForSalesItems: boolean;
    isForVisitSalesItems: boolean;
    isForVeterinarians: boolean;
    isForUsers: boolean;
    isForStates: boolean;
    isForStores: boolean;
    isForHospitals: boolean;

    constructor(params: Partial<ITraitModel>) {
        super(params);
        this.traitId = defaultTo(params.traitId, 0);
        this.name = defaultTo(params.name, "");
        this.isForSalesCategories = defaultTo(params.isForSalesCategories, false);
        this.isForSalesSubCategories = defaultTo(params.isForSalesSubCategories, false);
        this.isForSalesItems = defaultTo(params.isForSalesItems, false);
        this.isForVisitSalesItems = defaultTo(params.isForVisitSalesItems, false);
        this.isForVeterinarians = defaultTo(params.isForVeterinarians, false);
        this.isForUsers = defaultTo(params.isForUsers, false);
        this.isForStates = defaultTo(params.isForStates, false);
        this.isForStores = defaultTo(params.isForStores, false);
        this.isForHospitals = defaultTo(params.isForHospitals, false);
    }
}
